// extracted by mini-css-extract-plugin
export default {"root":"MultiColorSelectOption-module-root-w_4KF","loading":"MultiColorSelectOption-module-loading-mKpqK","image":"MultiColorSelectOption-module-image-BXzU3"};